import * as React from 'react'

const Option = (props: React.HTMLAttributes<HTMLOptionElement>): JSX.Element => (
  <option {...props} />
)

export default Option



// WEBPACK FOOTER //
// ./src/components/_atoms/selectOption.tsx